import React from 'react';
import {
  Grid,
  Card,
  Container,
  CardContent,
  Typography,
  Badge,
  Box,
} from '@mui/material';
import Header from '../components/Admin/header/Header';
import Sidebar from '../components/Admin/Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { Search } from '@mui/icons-material';
import { UserPlus, X } from 'lucide-react';


const sections = [
  {
    name: 'Maternity Care Package',
    description:
      'Show list of all the OPD Consultations made by patients.  ',
    icon: '/Images/patient.svg',
  },
  {
    name: 'Diabetes Care Package',
    description:
      'Show list of all the Outsider Consultation.',
    icon: '/Images/bank.svg',
  },
  {
    name: 'Surgery Package',
    description:
      'Show list of all the IPD Consultations.',
    icon: '/Images/operations.svg',
  },
];

const Packages = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/patient/packages/details');
}

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: 'flex' }}>
        <Box sx={{}}>
          <Sidebar />
        </Box>

        {/* Search  */}
        <Box
            sx={{
              paddingTop: '20px',
              display: 'flex',
              flexDirection:'column',
              marginBottom: '20px',
              marginRight: '80px',
            }}
          > 

        <Box
            sx={{
              paddingTop: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
              marginRight: '80px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                backgroundColor: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
              }}
            >
              <select className="uid-select">
                <option value="UHID">UHID</option>
                <option value="firstName">Patient's First Name</option>
                <option value="contactNo">Contact Number</option>
              </select>
              <div className="search-input-wrapper">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  placeholder={`Search by `}
                  className="search-input"
                />
                
                  <button
                    className="clear-search"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#999',
                    }}
                  >
                    <X size={16} />
                  </button>
              </div>
            </Box>
            <Box>
              <button className="patient-registration" onClick={()=>{
                navigate('/consultation/form');
              }}>
                <UserPlus size={20} />
                Add Consultation
              </button>
            </Box>
          </Box>
          <Typography variant="h6" color="#5D6A82" mt={2}>
            Types of Packages
          </Typography>

          {/* cards */}
        <Box sx={{ paddingTop: '20px', marginRight: '90px' }}>
          <Box sx={{ mb: 4 }}>
            <Grid container spacing={2}>
              {sections.map((item, idx) => (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Card
                  onClick={handleClick}
                    variant="outlined"
                    sx={{
                      height: 120,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      borderRadius: 2,
                      padding:1,
                      cursor:'pointer',
                      border:'1px solid #92A6CC'
                    }}
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        justifyContent=""
                        alignItems="center"
                        gap={1}
                      >
                    
                        <Typography variant="h6" sx={{}} color={'#5D6A82'}>
                          {item.name}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body3"
                        color="textSecondary"
                        sx={{
                          mt: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                        }}
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Packages;